import shiftRequestDetailsStore from "../../store/store";
import { IMemberEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_MANAGER_MEMBER', function setManagerMemberInStore(member: IMemberEntity) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.managerMember = member;
    }
});
